import React from 'react'

export default function MindVideo() {
  return (
    <div className="max-w-6xl mx-auto pt-4 space-y-6">
      <h2 className="px-3 text-3xl text-center mt-6 font-bold">
        Visual Wellness
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/BpzVvUGfJeA?si=tRpuzdKh-WO-QOVA"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/wOGqlVqyvCM?si=mQVGkvuNiWE766zX"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe></div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/db3K8b3ftaY?si=fDMsRY3nQFcE0yjv"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/_5OkC09xP34?si=KX7iZpTYD9yMNZoA"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/7EX1Xnvvk5c?si=XCVZyyitInlmhX5K"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/iNyUmbmQQZg?si=gznugUC45hg1g6yz"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/IaSpas9hWNQ?si=VX82weNHDCBgl2A4"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/d1sVO6x9p5U?si=ImPcvKV-dTzyl3LD"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/OTQJmkXC2EI?si=c0erST0d2zect2CR"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/O9qRyFOLdQk?si=7-3jlIzPMJS8re0b"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/tBGvOmUhhq4?si=dWpkaPMdYY1Mr1ie"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/-GXfLY4-d8w?si=zUIN9TMvvlOBiqh8"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        </div>
      </div>
    </div>
  );
}
